export const CHART_INFO = 'ChartInfoTemplate';
export const QUERY_SAVE = 'ChartQuerySave';
export const CONFIRM = 'ConfirmModal';
export const ALERT = 'AlertModal';

export default {
    CHART_INFO,
    QUERY_SAVE,
    CONFIRM,
    ALERT,
};
